export function formatUom(value: string, suffix?: string) {
  const formattedValue = getFormattedValue(value);

  return !!suffix
    ? `${formattedValue}${suffix}`
    : formattedValue;
}


// TODO: consider using `VolumeUnit`. May require fuelWRAp backend refactoring.
function getFormattedValue(value: string) {
  switch (value.toLowerCase()) {
  //
  // Height
  //
  case 'inches':
    return 'in.';
  case 'centimeters':
    return 'cm.';
  case 'millimeters':
  case 'millimetres':
    return 'mm.';

  //
  // Volume
  //
  case 'gallon':
  case 'gallons':
    return 'gal.';
  case 'liter':
  case 'liters':
  case 'litre':
  case 'litres':
    return 'l';

  //
  // Temperature
  //
  case 'fahrenheit':
    return 'º F';
  case 'celsius':
    return 'º C';

  default:
    return value;
  }
}
